module.exports = __webpack_public_path__ + "img/lunbo03_01.6e0fdfc9.jpg";